export const COLLECTION_API_BASE_PATH = '/backoffice/collection';
export const MASTER_DATA_BASE_PATH = '/backoffice/master-data';

export const COLLECTION_API_ENDPOINTS = {
  LHC_LIST: `${COLLECTION_API_BASE_PATH}/lhc`,
  LHC_DETAIL: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}/items`,
  LHC_DELIVERY_ORDERS: (id: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/delivery-orders`,
  LHC_ITEM_MUTATIONS: (id: string, itemId: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/items/${itemId}/mutations`,
  LHC_DUPLICATE: (id: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/duplicate`,
  LHC_RELATED_DELIVERY_ORDERS: (id: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/delivery-orders/related`,
  LHC_ADD_ITEMS: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}/items`,
  CREATE_LHC: `${COLLECTION_API_BASE_PATH}/lhc`,
  UPDATE_LHC: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}`,
  LHC_DELETE: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}`,
  LHC_DELETE_ITEM: (id: string, itemId: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/items/${itemId}`,
  LHC_ITEM_REORDER: (id: string, itemId: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/items/${itemId}/reorder`,
  LHC_ITEM_REMARK: (id: string, itemId: string) =>
    `${COLLECTION_API_BASE_PATH}/lhc/${id}/items/${itemId}/remark`,
  LHC_EXPORT: (id: string) => `${COLLECTION_API_BASE_PATH}/lhc/${id}/export`,
  COLLECTION_PAYMENT_PROOF_DETAIL: (
    paymentProofId: string,
    orderMetaId: string
  ) =>
    `${COLLECTION_API_BASE_PATH}/payment-proofs/${paymentProofId}/order/${orderMetaId}`,
  COLLECTION_MUTATION_DETAIL: (mutationId: string, orderMetaId: string) =>
    `${COLLECTION_API_BASE_PATH}/mutations/${mutationId}/order/${orderMetaId}`,
  COLLECTION_BILTO_DETAIL: (sapNoBilto: string) =>
    `${COLLECTION_API_BASE_PATH}/bilto/${sapNoBilto}`,
  COLLECTION_PLANTS: `${MASTER_DATA_BASE_PATH}/collection-plants`,
};

export const COLLECTION_QUERY_KEYS = {
  LHC_LIST: 'CollectionLHCList',
  LHC_DETAIL: 'CollectionLHCDetail',
  COLLECTION_BILTO_DETAIL: 'CollectionBiltoDetail',
  COLLECTION_PLANTS: 'CollectionPlants',
  RELATED_DELIVERY_ORDERS: 'RelatedDeliveryOrders',
} as const;
